<template>
	<!-- la URL que envia el email debe ser http://localhost:8080/clients/welcome?request=REQUESTID&token=TOKENREQUEST&user=client -->
	<CContainer class="d-flex content-center bg-white">
		<div class="">
			<CRow>
				<CCol sm="5" class="">
					<img
						class="img-fluid"
						:src="this.imgInfofriend1"
						alt="infoFriend1"
					/>
				</CCol>
				<br />
				<CCol sm="7" class="" style="margin-top: 70px;">
					<h3 class="borderInfoFriend">¡Hola Infoamigo!</h3>
					<br />
					<p class="h5">Te recordamos que...</p>
					<p class="h5">
						No se trata de cuantas estrategias tengas, sino de cómo
						las usas
					</p>
					<p class="h5">
						Y la mejor decisión que haz podido tomar es: <br />
						<b>¡Ser parte del Team Infoguia!</b>
					</p>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol sm="12">
					<p class="h5">
						Para continuar con el proceso de actualización de datos
						de forma <b>gratuita</b> presiona el siguiente botón
					</p>
				</CCol>
			</CRow>
			<br />
			<CRow class="content-center">
				<CCol sm="12">
					<CButton
						size="lg"
						color="success"
						shape="pill"
						@click="clickButtonToForm"
						><b>¡Actualizar gratis mis datos ahora!</b></CButton
					>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol sm="12">
					<p class="h5">
						¿Sabías que también tenemos planes para destacarte
						frente a tu competencia?
					</p>
				</CCol>
			</CRow>
			<br />
			<CRow>
				<CCol sm="12" class="bg-dark">
					<p class="h3">¡Desde un increíble precio!</p>
				</CCol>
			</CRow>
			<br />
			<CRow class="content-center">
				<CCol sm="7" style="margin-top: 80px;" class="content-left">
					<h5 class="h5"><b>Para una suma significante de:</b></h5>
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Mayor alcance de clientes -->
						<span style="color:#97CA3D;font-size: 30px;"
							><i
								class="fas fa-check-double"
								aria-hidden="true"
							></i
						></span>
						Mayor alcance de clientes
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Tráfico en tus redes sociales -->
						<span style="color:#97CA3D;font-size: 30px;"
							><i
								class="fas fa-check-double"
								aria-hidden="true"
							></i
						></span>
						Tráfico en tus redes sociales
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Posicionamientoen la búsqueda de tu web -->
						<span style="color:#97CA3D;font-size: 30px;"
							><i
								class="fas fa-check-double"
								aria-hidden="true"
							></i
						></span>
						Posicionamientoen la búsqueda de tu web
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Aumento de visibilidad en la web de tu marca -->
						<span style="color:#97CA3D;font-size: 30px;"
							><i
								class="fas fa-check-double"
								aria-hidden="true"
							></i
						></span>
						Aumento de visibilidad en la web de tu marca
					</h5>
					<br />
					<h5>
						<!-- <CIcon :height="20" name="cil-check" /> Atracción y credibilidad -->
						<span style="color:#97CA3D;font-size: 30px;"
							><i
								class="fas fa-check-double"
								aria-hidden="true"
							></i
						></span>
						Atracción y credibilidad
					</h5>
					<br />
				</CCol>
				<CCol sm="5" class="">
					<img
						class="img-fluid"
						:src="this.imgInfoFriend2"
						alt="infoFriend2"
					/>
				</CCol>
			</CRow>
			<br />
			<CRow class="">
				<CCol sm="12" class="">
					<img
						class="img-fluid"
						:src="this.imgCompare"
						alt="compare"
					/>
				</CCol>
			</CRow>
			<br />
			<br />
			<!-- modales -->
			<div>
				<!-- modal indicando que el cliente solicito no actualizar sus datos -->
				<CModal
					:show.sync="modalAlreadyNotUpdate"
					:close-on-backdrop="false"
					:centered="true"
					title="No actualizar mis datos"
					size="sm"
					color="warning"
				>
					{{ errorMessage }}
					<template #header>
						<h6 class="modal-title">Ya existe una solicitud</h6>
						<CButtonClose
							@click="modalAlreadyNotUpdate = false"
							class="text-white"
						/>
					</template>
					<template #footer>
						<b-button
							@click="modalAlreadyNotUpdate = false"
							variant="outline-info"
							size="lg"
							class="mr-1"
							>Cerrar
						</b-button>
					</template>
				</CModal>
			</div>
		</div>
	</CContainer>
</template>
<script>
	export default {
		/**Componente usada para dar la bienvenida al cliente antes de ir al formulario para actualizar sus datos */
		name: 'FormClient',
		title: 'Hola Infoamigo | Infoguia',
		beforeCreate: function() {
			sessionStorage.removeItem('accessToken');
			sessionStorage.removeItem('stepFilled');
			sessionStorage.setItem('idRequest', this.$route.query.re);
			sessionStorage.setItem('userType', this.$route.query.u);
			sessionStorage.setItem('goBackUrl', this.$route.fullPath);
		},
		created() {},
		data() {
			return {
				imgInfofriend1: process.env.VUE_APP_WELCOME_INFOFRIEND1,
				imgInfoFriend2: process.env.VUE_APP_WELCOME_INFOFRIEND2,
				imgCompare: process.env.VUE_APP_WELCOME_COMPARE,
				modalAlreadyNotUpdate: false,
				errorMessage: '',
			};
		},
		methods: {
			clickButtonToForm() {
				let loader = this.$loading.show();
				let idRequest = sessionStorage.getItem('idRequest');
				let tokenForRequest = this.$route.query.to;
				this.$http
					.get(
						'/api/v1/requestsrows/' +
							idRequest +
							'/verify/' +
							tokenForRequest
					)
					.then((dataClient) => {
						let token = dataClient.data.data.token;
						sessionStorage.setItem('accessToken', token);
						sessionStorage.setItem(
							'stepFilled',
							dataClient.data.data.RequestsRows.stepFilled
						);
						this.$router.push({
							name: 'FormClient',
						});
					})
					.catch((errors) => {
						console.log(errors.response);
						let errorCode = errors.response.data.code;
						switch (errorCode) {
							case 404:
								this.$router.push({
									name: 'Page404',
									// params: {
									//     id: event,
									// }
								});
								break;
							case 409:
								this.modalAlreadyNotUpdate = true;
								this.errorMessage = errors.response.data.error;
								break;
						}
					})
					.finally(() => {
						loader.hide();
					});
			},
		},
	};
</script>
